import { useEffect, useRef, useState, useCallback } from 'react'
import { SActionBtn, SBack, SLowcodeList, SMessage, STableActions } from 'shj-components'
import config from './config'
import { apiData2Table } from '@/utils/data'
import { useParams } from 'react-router-dom'
import { Button, message, Upload } from 'antd'
import { fileDownload } from '@/utils/download'
import UrlConfig from '@/api/UrlConfigs'
import { getBudgetTypeEnumNew } from '@/services/goods'
import AddConfigDrawer from '../modalOrDrawers/addConfigDrawer'
import {
  deleteCostTemplateBatch,
  deleteCostTemplateDetail,
  getCostTemplateDetail,
  importCostTemplate,
} from '@/services/product'

const FeeTemplateDetail = () => {
  const { id: costTemplateId, name } = useParams() || {}
  const listRef = useRef<any>()
  const [open, setOpen] = useState(false)
  const [budgetList, setBudgetList] = useState<any>([])
  const [importLoading, setImportLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [rowIndexMap, setRowIndexMap] = useState<Map<string, number>>(new Map())

  // 获取列表数据
  const fetchList = (params: any) => {
    return new Promise((resolve, reject) => {
      try {
        getCostTemplateDetail({
          params: {
            pageId: params.current,
            pageSize: params.pageSize,
          },
          data: {
            costTemplateId,
            quoteType: params.query.quoteType,
            searchFlag: true,
          },
        }).then((res: any) => {
          const data = apiData2Table(res)

          // 为每行数据添加索引
          const newMap = new Map()
          res.list.forEach((item, index) => {
            newMap.set(item.id, index)
          })
          setRowIndexMap(newMap)

          resolve(data)
        })
      } catch (error) {
        reject({ success: false })
      }
    })
  }

  // 获取报价类型
  const getBudgetList = async () => {
    // 报价类型
    const budgetRes: any = await getBudgetTypeEnumNew()
    listRef.current?.updateSearchData('budgetList', budgetRes)
    setBudgetList(budgetRes)
  }

  // 批量删除
  const batchDelete = useCallback(({ selectedRowKeys }) => {
    SMessage.confirm({
      title: '提示',
      content: '确定要批量删除选中的配置吗？',
      onOk: () => {
        deleteCostTemplateBatch(selectedRowKeys).then(() => {
          message.success('删除成功')
          listRef.current?.reload()
        })
      },
    })
  }, [])

  // 添加配置
  const addConfig = () => setOpen(true)

  // 删除配置
  const deleteConfig = (record: any) => {
    SMessage.confirm({
      title: '提示',
      content: '确定删除该配置吗？',
      onOk: () => {
        deleteCostTemplateDetail(record.id).then(() => {
          message.success('删除成功')
          listRef.current?.reload()
        })
      },
    })
  }

  // 下载模版
  const downloadTemplate = () => {
    setDownloadLoading(true)
    fileDownload(UrlConfig.PlusProductWeb.DownloadCostTemplate)
      .then(() => setDownloadLoading(false))
      .catch(() => setDownloadLoading(false))
  }

  // 批量导入
  const batchImport = (upload: any) => {
    setImportLoading(true)
    const { file, onSuccess, onError } = upload
    const data = new FormData()
    data.append('file', file)
    return importCostTemplate({ data, params: { costTemplateId } })
      .then((res: any) => {
        listRef.current?.reload()
        onSuccess && onSuccess()
        message.success(res.message || '导入成功')
      })
      .catch(onError)
      .finally(() => setImportLoading(false))
  }

  // 导出
  const exportTemplate = () => {
    setExportLoading(true)
    fileDownload(
      UrlConfig.PlusProductWeb.ExportCostTemplate + `?costTemplateId=${costTemplateId}`,
      {
        method: 'POST',
      }
    )
      .then(() => setExportLoading(false))
      .catch(() => setExportLoading(false))
  }

  const extension = {
    request: { fetchList },
    events: { batchDelete, addConfig, exportTemplate },
    // auth: authMap,
    status: {},
    customRender: {
      // 序号
      numberRender(_text: any, record: Record<string, any>) {
        return <span>{(rowIndexMap.get(record.id) || 0) + 1}</span>
      },
      // 操作
      actionTool(_text: any, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn danger onClick={() => deleteConfig(record)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
      // 下载导入模版
      downloadRender() {
        return (
          <Button onClick={() => downloadTemplate()} loading={downloadLoading}>
            下载导入模板
          </Button>
        )
      },
      // 批量导入
      importRender() {
        return (
          <Upload listType="text" customRequest={batchImport} itemRender={() => null}>
            <Button loading={importLoading}>批量导入</Button>
          </Upload>
        )
      },
      // 导出
      exportRender() {
        return (
          <Button onClick={() => exportTemplate()} loading={exportLoading}>
            导出
          </Button>
        )
      },
    },
  }

  useEffect(() => {
    getBudgetList()
  }, [])

  return (
    <SBack level={2} title={`${name} 模板配置`}>
      <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} />
      <AddConfigDrawer
        open={open}
        budgetList={budgetList}
        onCancel={() => setOpen(false)}
        listRef={listRef}
      />
    </SBack>
  )
}

export default FeeTemplateDetail
